import DataGridComponent from "components/DataGridComponent/DataGridComponent"
import { DeleteDialog } from "components/DeleteDialog/DeleteDialog"
import { QRCodeGenerator } from "components/QRCodeGenerator/QRCodeGenerator"
import { Device, DeviceAux, DeviceType } from "graphql/types"
import { useStoreActions, useStoreState } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { AddAuxEquipmentDialog } from "./AddAuxEquipmentDialog"

const emptyAuxEquipment: DeviceAux = {
  id: "",
  type: DeviceType.AUX,
  barcode: "",
  images: [],
  documents: [],
  name: "",
  description: "",
  movementData: [],
  deviceDataGroup: [],
}

const AdminAuxEquipment = () => {
  const auxEquipment = useStoreState((state) => state.auxEquipment)
  const { updateAuxEquipment, deleteAuxEquipment, fetchAuxEquipment } =
    useStoreActions((actions) => actions)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [formState, setFormState] = useState<DeviceAux>(emptyAuxEquipment)
  const [openDelete, setOpenDelete] = useState(false)
  const [toDelete, setToDelete] = useState<string[]>([])
  const [openQRCodeGenerator, setOpenQRCodeGenerator] = useState(false)

  useEffect(() => {
    fetchAuxEquipment()
  }, [fetchAuxEquipment])

  const handleEdit = (id: string) => {
    if (id === "NEW") {
      setFormState({
        ...emptyAuxEquipment,
        id: "NEW",
        barcode: `AUX-${new Date().getFullYear()}-${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
      })
    } else {
      const aux = auxEquipment.find((item) => item.id === id) as DeviceAux | undefined
      if (aux) {
        setFormState({
          ...aux,
          movementData: aux.movementData || [],
          deviceDataGroup: aux.deviceDataGroup || [],
          images: aux.images || [],
        })
      }
    }
    setDialogOpen(true)
  }

  const handleDelete = (id: string[]) => {
    setOpenDelete(true)
    setToDelete(id)
  }

  const handleDeleteSelected = () => {
    deleteAuxEquipment(toDelete)
    setToDelete([])
    setOpenDelete(false)
  }

  const handleDialogClose = () => {
    setDialogOpen(false)
  }

  const handleFormSubmit = (arg: DeviceAux) => {
    updateAuxEquipment(arg)
    setDialogOpen(false)
  }

  const handleQRCode = (row: Device) => {
    setOpenQRCodeGenerator(true)
    setFormState(row as DeviceAux)
  }

  const columns = [
    { field: "barcode", headerName: "Barcode", width: 150 },
    { field: "name", headerName: "Bezeichnung", width: 200 },
    { field: "description", headerName: "Beschreibung", width: 300 },
    {
      field: "deviceDataGroup",
      headerName: "Gerätegruppen",
      width: 200,
      renderCell: (params: any) => {
        return params.row.deviceDataGroup
          ?.map((group: any) => group.name)
          .join(", ")
      },
    },
  ]

  return (
    <>
      <DataGridComponent
        rows={auxEquipment}
        columns={columns}
        getRowId={(row) => row.id}
        onEdit={handleEdit}
        onAdd={() => handleEdit("NEW")}
        onQRCode={handleQRCode}
        onDelete={handleDelete}
        title="AUX Verwaltung"
      />
      <AddAuxEquipmentDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        formState={formState}
        onSubmit={handleFormSubmit}
      />
      <DeleteDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onDelete={handleDeleteSelected}
      />
      {openQRCodeGenerator && (
        <QRCodeGenerator
          open={openQRCodeGenerator}
          onClose={() => setOpenQRCodeGenerator(false)}
          barcode={formState.barcode}
          title={`AUX: ${formState.name}`}
        />
      )}
    </>
  )
}

export default AdminAuxEquipment